<template>
  <div class="d-flex justify-content-center mt-3">
    <div class="card p-6 m-6 form-card shadow-sm">

      <!-- User Name -->
      <div class="mb-3">
        <label class="form-label ">
          User Name<span class="text-danger">*</span>
        </label>
        <el-select
          v-model="selectedUserId"
          placeholder="Please select user name"
          class="w-100"
          filterable
          @change="onChangeUser"
        >
          <el-option
            v-for="item in userNameList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </el-select>
        <small class="text-danger">{{ errors.userName }}</small>
      </div>

      <!-- Domain -->
      <!-- <div class="mb-3">
        <label class="form-label ">
          Domain<span class="text-danger">*</span>
        </label>
        <el-select
          v-model="selectedDomain"
          placeholder="Please select domain"
          class="w-100"
          @change="errors.domain = ''"
        >
          <el-option
            v-for="item in domainList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </el-select>
        <small class="text-danger">{{ errors.domain }}</small>
      </div> -->

      <!-- Customer Account -->
      <div class="mb-3">
        <label class="form-label ">
          Customer Account <span class="text-danger">*</span>
        </label>
        <el-select
          v-model="selectedCustomer"
          multiple
          filterable
          collapse-tags
          collapse-tags-tooltip
          placeholder="Please select customer account"
          class="w-100"
          @change="errors.customer = ''"
        >
          <el-option
            v-for="item in sortedCustomerList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </el-select>
        <small class="text-danger">{{ errors.customer }}</small>
      </div>
      <div class="mb-3">
        <el-checkbox v-model="invoiceScanning">
          <div class="form-label">
            Invoice Scanning
          </div>
        </el-checkbox>
      </div>
      <!-- Button -->
      <button
            class="btn btn-primary px-4 d-flex align-items-center justify-content-center"
            @click="submit"
            :disabled="isLoading"
      >
        <span v-if="!isLoading">Save</span>
        <!-- Loader -->
        <span v-else class="spinner-border spinner-border-sm"></span>
      </button>

    </div>
  </div>

  <!-- Toast -->
  <div
    v-if="showToastFlag"
    :class="['toast-box', toastType === 'success' ? 'bg-success' : 'bg-danger']"
  >
    {{ toastMessage }}
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import store from "@/store";

export default defineComponent({
  name: "AddClients",

  setup() {
    let mailid = store.getters.emailid;
    let domainName = store.getters.DomainName.toLowerCase();
    let id = store.getters.UserId;
    // ✅ Reactive variables
    const userNameInput = ref("");
    const selectedDomain = ref([]); // selected values
    const selectedCustomer = ref([]); // selected values
    const selectedUserId = ref([]); // selected values
    const selectedUserName = ref([]);
    const domainList = ref([]);      // dropdown list
    const customerList = ref([]);      // dropdown list
    const userNameList = ref([]);      // dropdown list
    const errors = ref({
    userName: "",
    customer: "",
    domain: "",
    });
    const invoiceScanning = ref(false);
    const toastMessage = ref("");
    const toastType = ref(""); // success / error
    const showToastFlag = ref(false);
    const isLoading = ref(false);    

    onMounted(() => {
      setCurrentPageBreadcrumbs("Add Clients", ["NA"]);
      getUserDetails(0);
    });

    const sortedCustomerList = computed(() => {
      return [...customerList.value].sort((a, b) => {
        const aSelected = selectedCustomer.value.includes(a.key);
        const bSelected = selectedCustomer.value.includes(b.key);

        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;

        return a.name.localeCompare(b.name);
      });
    });

    const getUserDetails = (Id) => {
      ApiService.get( `api/users/userManagement` )
        .then((resp) => {
          userNameList.value = resp.data.usermodel.map((a) => ({
              key: a.id,
              name: a.username, // adjust if API uses different field
              domainId : a.DomainId,
              invoicescanning: a.invoicescanning
            }));
            console.log(Id,'Id value')
            if(Id != 0){
              invoiceScanning.value = userNameList.value.find(a => a.key === Id).invoicescanning;
            }            
            console.log(userNameList,'user name list records')
        })
        .catch((a) => {
          console.log("API Error", a);
        });
    }
    

    ApiService.get( `api/users/getClient/${id}/${domainName}` )
      .then((resp) => {
         customerList.value = resp.data.usermodel.map((a) => ({
            key: a.id,
            name: a.username, // adjust if API uses different field
          }));
          domainList.value = resp.data.domainmodel.map((a) => ({
            key: a.DomainId,
            name: a.DomainName
          }));
      })
      .catch((a) => {
        console.log("API Error", a);
      });

    const getCustomer = (id) =>{
      console.log(id,'customer Id value')
      ApiService.get(`api/users/getCustomer/${id}`)
        .then((resp) => {
            console.log(resp,'response value')
            selectedCustomer.value = resp.data.usermodel.map((a) => (a.id));           
      })
      .catch((a) => {
        console.log("API Error", a);
      });
    }    
    
    const onChangeUser = async (id) => {
      console.log(id,'onchange user id')
      errors.value.customer = "";
      errors.value.userName = "";
      errors.value.domain = "";
      let domain = userNameList.value.find( a => a.key === id);
      console.log(domain,'username list value')
      if(domain){
        selectedDomain.value = domain.domainId;
        selectedUserName.value = domain.name;
        //invoiceScanning.value = domain.invoicescanning;
      }       
      await getCustomer(id);     
      await getUserDetails(id);
    }

    const validateForm = () => {
        let isValid = true;

        errors.value = {
            userName: "",
            customer: "",
            domain: "",
        };

        if (!selectedUserId.value || selectedUserId.value.length == 0) {
            errors.value.userName = "User Name is required";
            isValid = false;
        }

        if (!selectedCustomer.value || selectedCustomer.value.length == 0) {
            errors.value.customer = "Customer Account is required";
            isValid = false;
        }

        // if (!selectedDomain.value || selectedDomain.value.length == 0) {
        //     errors.value.domain = "Domain is required";
        //     isValid = false;
        // }

        return isValid;
    };

    // ✅ Submit function
    const submit = async () => {
        if (!validateForm()) return;
        isLoading.value = true; // ✅ start loading
        const payload = {
            id: selectedUserId.value,
            username: selectedUserName.value,
            domainid: "1", /*selectedDomain.value,*/
            accountid: selectedCustomer.value.join('|'),
            last_update_user: mailid,
            DomainName: "",
            invoicescanning: invoiceScanning.value,
        };
        console.log(payload,'payload value')
        try {
            const resp = await ApiService.post("api/users/updateUser", payload);

            if (resp.data.usermodel[0].resStatus === "S") {
                showToast(resp.data.usermodel[0].resMessage, "success");

                // clear form
                selectedUserName.value = [];
                selectedUserId.value = [];
                selectedDomain.value = [];
                selectedCustomer.value = [];
                selectedUserName.value = [];
                invoiceScanning.value = false;
              getUserDetails(0);
            } else {
                showToast(resp.data.usermodel[0].resMessage, "error");
            }
        } catch (e) {
            showToast("Something went wrong", "error");
        } finally {
            isLoading.value = false; // ✅ stop loading
        }
    };

    const showToast = (msg, type) => {
        toastMessage.value = msg;
        toastType.value = type;
        showToastFlag.value = true;

        setTimeout(() => {
            showToastFlag.value = false;
        }, 3000);
    };

    return {
        selectedUserId,
        selectedUserName,
        invoiceScanning,
        selectedDomain,
        selectedCustomer,
        sortedCustomerList,
        domainList,
        customerList,
        userNameList,
        submit,
        onChangeUser,
        errors,
        showToastFlag,
        toastMessage,
        toastType,
        isLoading,
    };
  },
});
</script>
<style scoped>
    .form-card {
        width: 350px;
        border-radius: 10px;
    }

    .form-label{
        color: rgb(46, 49, 146)
    }

    .toast-box {
        position: fixed;
        bottom: 20px;
        right: 20px;
        color: white;
        padding: 12px 20px;
        border-radius: 5px;
        z-index: 9999;
    }

    .text-danger {
        font-size: 12px;
    }

    .eye-icon {
        position: absolute;
        right: 15px;
        top: 38px;
        cursor: pointer;
        color: #6c757d;
    }
</style>